import { Options } from '@modeso/types__aumico-lib-notes-be';

export interface IComponentOptionsDelegate {
    savedOptions(options: Options, componentId: string): void;
}
